import { useQuery } from "@tanstack/react-query";
import { User } from "../../types/user";
import { getUserByUid } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

function createUserByUidQueryOptions(uid: string) {
  return {
    queryKey: ["user", "byUid", uid],
    queryFn: () => getUserByUid(uid),
    staleTime: INTERVAL.DAY,
    // ponytail: gcTime must be >= staleTime, otherwise the default 5min
    // gcTime evicts the cache before staleTime expires, silently defeating it
    gcTime: INTERVAL.DAY,
    refetchOnWindowFocus: false,
  };
}

export function useUser(uid: string) {
  return useQuery<User>({
    ...createUserByUidQueryOptions(uid),
    enabled: !!uid,
  });
}
